import { render, staticRenderFns } from "./BreedList.vue?vue&type=template&id=98116080&scoped=true&"
import script from "./BreedList.vue?vue&type=script&lang=js&"
export * from "./BreedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98116080",
  null
  
)

export default component.exports